import React from 'react';
import { makeStyles, Grid, Typography, IconButton } from '@material-ui/core';
import { Paper } from '../components'
import { CircleArrowFowardIcon } from '../icons'
import { useHistory } from 'react-router-dom'

export default function SupportScreen(props) {

  const classes = useStyles({...props})()
  const history = useHistory()

  return (
    <Grid container className={classes.container}>
      <Grid container className={classes.containerHeader} justify="center" alignItems="flex-start" style={{padding:"5px 5px 9px 5px"}}>
        <Grid item xs={7} md={3}>
          <img src="../../assets/soporte.svg" alt="" />
        </Grid>
        <Grid item md={9}>
          <Grid container>
            <Grid item md={12} lg={11}>
              <Typography >Soporte</Typography>
            </Grid>
            <Grid item xs={12} md={12} style={{margin:"30px 0 0 0"}}>
              <Typography >Saludos, Dr. (a) <br/> ¿En que podemos ayudarlo(a)?</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={9}  className={classes.titleSupportDesktop}>
          <Typography ></Typography>
        </Grid>
      </Grid>
      <Paper>
        <Grid container className={classes.containerPaper}>
          <Grid item xs={12} className={classes.titleSupport}>
              <Typography align="center">Saludos, Dr. (a) <br/> ¿En que podemos ayudarlo(a)?</Typography>
          </Grid>
          <Grid item xs={12} style={{margin:"20px 0"}}>
              <Grid container className={classes.box} onClick={() => history.push('/unio-support')}>
                <div><Typography>Soporte Unio</Typography></div>
                <div><IconButton ><CircleArrowFowardIcon /></IconButton></div>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{margin:"20px 0"}}>
              <Grid container className={classes.box} onClick={() => history.push('/lab-support')}>
                <div><Typography>Soporte Laboratorio</Typography></div>
                <div><IconButton ><CircleArrowFowardIcon /></IconButton></div>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}


const useStyles = ({buttonActive, ...props}) => makeStyles((theme) => ({
  container:{
    display:"block",
    height: "100%",
    [theme.breakpoints.up("md")]:{
      padding:"50px 50px 0 50px",
    }
  },
  titleSupport:{
    [theme.breakpoints.up("md")]:{
      display:"none"
    }
  },
  titleSupportDesktop:{
    [theme.breakpoints.down("sm")]:{
      display:"none"
    }
  },
  containerHeader:{
    '& > div:nth-child(1)':{
      '& img':{
        [theme.breakpoints.up("md")]:{
          width:"100%",
        }
      }
    },
    '& > div:nth-child(2)':{
      padding:" 0 0 0 40px",
      [theme.breakpoints.down("sm")]:{
        display:"none"
      },
      '& > div':{
        '& > div:nth-child(1), > div:nth-child(2)':{
          '& > p':{
            color:theme.palette.primary.main,
            fontSize:"1.125rem",
            lineHeight:"1.375rem",
            fontWeight:"bold",
          }
        }
      }
     
    },
  },
  containerPaper:{
    height:"60vh", 
    display:"block",
    '& > div:nth-child(1)':{
        '& p:nth-child(1)':{
            color:theme.palette.primary.main,
            fontSize:"1.125rem",
            lineHeight:"1.375rem",
            fontWeight:"bold",
        },
        '& p':{
            color:theme.palette.secondary.main,
            fontSize:"0.875rem",
            lineHeight:"1.063rem",
            fontWeight:"500",
            margin:"10px 0 0 0",
        },
    }
  },
  box:{
    background: "#FFFFFF",
    boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
    borderRadius: 22,
    width: "100%",
    height: 55,
    padding:13,
    cursor:"pointer",
    [theme.breakpoints.up("md")]:{
      alignItems:"center"
    },
    '& div':{
      height:  "100%", 
      width:"80%",
      [theme.breakpoints.up("md")]:{
        width:"90%"
      },
      display:"flex", 
      justifyContent:"flex-start", 
      alignItems:"center",
      '& p':{
        fontSize: "1.125rem",
        lineHeight:"1.375rem",
        fontWeight: "500",
        color:theme.palette.primary.main

      }
    },
    '& div:nth-child(2)':{
      width:"20%",
      '& img':{
        objectFit:"contain"
      },
      [theme.breakpoints.up("md")]:{
        width:"10%"
      }
    },
  }
}));